package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_05_03_Day_1
import com.veldekar.components.logs.Log_2024_05_03_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-05-03")
@Composable
public fun Log_2024_05_03(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Hezrou and Vrocks",
        ogTitle = "Hezrou and Vrocks",
        date = LocalDate(2_024, 5, 3),
        ogDescription = "The heroes clear the subterranean stronghold of Hezrou and Vrocks before resting to prepare for deeper depths.",
        ogImage = "ai/2024-05-03.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-51", dateString = "Newgrowth 51")
        Log_2024_05_03_Day_1()
        SessionDayHeader(dayId = "newgrowth-52", dateString = "Newgrowth 52")
        Log_2024_05_03_Day_2()
    }
}
